import React, { useState } from "react";
import { CognitoUserPool, CognitoUser } from "amazon-cognito-identity-js";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../utils/analytics";

const pool = new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID
});

export default function ConfirmRegistration() {
  const navigate = useNavigate();

  const [email, setEmail] = useState(
    localStorage.getItem("beercard_registration_email") || ""
  );

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleConfirm = (e) => {
    e.preventDefault();
    setLoading(true);
    trackEvent("registration_confirmation_started");

    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: pool
    });

    cognitoUser.confirmRegistration(
      code,
      true,
      async (err) => {
        if (err) {
          trackEvent("registration_confirmation_failed", { reason: err.code || "cognito_confirm_error" });
          alert(err.message);
          setLoading(false);
          return;
        }

        await fetch(
          `${process.env.REACT_APP_API_BASE}/register-user`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email: localStorage.getItem("beercard_registration_email"),
              firstName: localStorage.getItem("beercard_registration_firstName"),
              lastName: localStorage.getItem("beercard_registration_lastName"),

              club:
                localStorage.getItem("beercard_registration_club"),

              clubId:
                localStorage.getItem("beercard_registration_clubId"),

              team:
                localStorage.getItem("beercard_registration_team"),

              teamId:
                localStorage.getItem("beercard_registration_teamId"),

              role:
                localStorage.getItem("beercard_registration_role")
            })
          }
        );

        alert(
          "Registration confirmed. Awaiting admin approval."
        );
        trackEvent("registration_completed", { role: "player" });

        navigate("/login");
      }
    );
  };

  return (
    <div className="min-h-screen bg-[#111827] text-white px-4 py-8">

      <div className="
        mx-auto
        max-w-md
        rounded-2xl
        bg-[#1E2A38]
        p-6
        border
        border-white/10
        shadow-lg
      ">

        <h2 className="text-3xl font-extrabold text-center mb-2">
          Confirm Registration
        </h2>

        <p className="text-center text-gray-300 mb-6">
          Enter the code emailed to you.
        </p>

        <form
          onSubmit={handleConfirm}
          className="space-y-4"
        >

          <input
            className="
              w-full
              rounded-xl
              bg-[#243447]
              px-4
              py-3
            "
            value={email}
            onChange={(e)=>
              setEmail(e.target.value)
            }
            placeholder="Email"
          />

          <input
            className="
              w-full
              rounded-xl
              bg-[#243447]
              px-4
              py-3
            "
            value={code}
            onChange={(e)=>
              setCode(e.target.value)
            }
            placeholder="Confirmation code"
          />

          <button
            disabled={loading}
            className="
              w-full
              rounded-xl
              bg-[#F5A623]
              py-4
              font-bold
              text-[#1E2A38]
            "
          >
            {loading
              ? "Confirming..."
              : "Confirm & Finish"}
          </button>

        </form>

      </div>

    </div>
  );
}
